import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {Apollo} from 'apollo-angular';
import {ErrorService} from './error.service';
import {catchError, take} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {LanguageType} from '../graphql/globalTypes';
import {Location} from '@angular/common';
import gql from 'graphql-tag';
import {AppGetMe} from './__generated__/AppGetMe';
import {environment} from '../../../environments/environment';

const APP_GET_ME_QUERY = gql`
  query AppGetMe {
    me {
      id
      language
    }
  }
`;

interface ISO3166 {
  alpha2: string;
  urlBlock: string;
}

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  constructor(
    private router: Router,
    private location: Location,
    @Inject(LOCALE_ID) private locale: string,
    private apollo: Apollo,
    private errService: ErrorService,
  ) {}

  public static getLocaleDetails(language: LanguageType): ISO3166 {
    switch (language) {
      case LanguageType.DUTCH:
        return {
          alpha2: 'nl',
          urlBlock: '',
        };
      case LanguageType.ENGLISH:
        return {
          alpha2: 'en',
          urlBlock: 'en/',
        };
    }
  }

  private getLocalizedHref(targetLocale: ISO3166, urlTree: UrlTree): string {
    const path = this.location.prepareExternalUrl(urlTree.toString());

    if (targetLocale.alpha2 === 'nl') {
      // Regex removes language block from path: "/<lang>/(<rest of path>)" becomes "/<rest of path>"
      return path.replace(/^\/[^/]*(.*)/, '$1');
    }

    return `/${targetLocale.alpha2}` + path;
  }

  fixLocale() {
    this.apollo
      .watchQuery<AppGetMe>({
        query: APP_GET_ME_QUERY,
      })
      .valueChanges.pipe(
        take(1),
        catchError(error => {
          this.errService.handleDefault(error);
          return EMPTY;
        }),
      )
      .subscribe(data => {
        if (data.data?.me.language) {
          const targetLocale = LocalizationService.getLocaleDetails(data.data?.me.language);
          if (this.locale !== targetLocale.alpha2) {
            if (environment.production) {
              // window.location.href = this.getLocalizedHref(
              //   targetLocale,
              //   this.router.parseUrl(this.router.url),
              // );
            }
          }
        }
      });
  }
}
